import React from 'react'
import { motion } from 'framer-motion'
import ScaleUp from '../utility/scaleUpAnimation'
import SlideInLeft from '../utility/slideInLeftAnimation'
import SlideInTop from '../utility/slideInTopAnimation'

const Highlight = props => (
  <div className="md:flex md:space-x-16 md:items-center py-4 md:mx-auto border-b-2 border-slate-50">
    <div className="md:w-1/2">
      <SlideInTop>
          <h4 className="maingrad rounded p-8 text-white font-semibold text-xl">
            {props.main}
          </h4>
      </SlideInTop>
    </div>
    {props.description && (
      <div className="md:w-1/2">
      <SlideInTop>
        <p>{props.description}</p>
      </SlideInTop>
    </div>
    )}
  </div>
)

export default Highlight
